const isDev = process.env.NODE_ENV !== 'production';

const safeArgs = (args: unknown[]) => args.map(arg => {
    if (typeof arg === 'string') {
        return arg;
    }
    try {
        return JSON.parse(JSON.stringify(arg));
    } catch {
        return arg;
    }
});

export const logger = {
    debug: (...args: unknown[]) => {
        if (!isDev) return;
        console.debug(...safeArgs(args));
    },
    info: (...args: unknown[]) => {
        if (!isDev) return;
        console.info(...safeArgs(args));
    },
    warn: (...args: unknown[]) => {
        console.warn(...safeArgs(args));
    },
    error: (...args: unknown[]) => {
        console.error(...safeArgs(args));
    },
};

export default logger;
